import {BounceRole} from "@bounce/shared/consumer/declarations";

const PRE_LOGIN_ROLES = [BounceRole.NO_LOGIN_USER];

export const isPreLoginRole = (userRole?: BounceRole) => userRole && PRE_LOGIN_ROLES.includes(userRole);
